import { JSX, useEffect, useState } from "react";
import { CheckBox } from "../Common/Checkbox";
import { DaysOfWeek, MaxNumber, TutorSchedule, TutorScheduleNoTimeZone } from "../../firestore/Types/TutorProfileSchema";
import ReactSlider from "react-slider";
import { getDayFromChar } from "../../Utils/WeekdayHelpers";
import { getTimeSlotsFromNumber, convertToBinary, convertToNumber, getTimeString } from "../../Utils/TimeSlotUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
export function AvailabilitiesDay({ day, availability, schedule, setAvailability, setSchedule }: { day: DaysOfWeek, availability: string, schedule: TutorSchedule, setAvailability: (availability: string) => void, setSchedule: (schedule: TutorSchedule) => void }): JSX.Element {
    const [availableTimes, setAvailableTimes] = useState([] as string[]);
    const [isAdding, setIsAdding] = useState(false);
    const [isSelected, setIsSelected] = useState(false);
    const [sliderValue, setSliderValue] = useState([0, 48]);
    
    const [isAvailable, setIsAvailable] = useState(false);

    var bordercolor = "border-slate-300";
    var textcolor = "text-slate-400";
    var colorBackground = "bg-slate-200";
    if (isAvailable === true) {
        bordercolor = "border-green-400";
        colorBackground = "bg-green-300";
        textcolor = "text-green-500"
    }

    const dayString = getDayFromChar(day);

    var timeslot = 0;
    if (schedule) {
        timeslot = schedule[dayString as unknown as keyof TutorScheduleNoTimeZone];
    }

    useEffect(() => {
        if (availability.includes(day)) {
            setIsAvailable(true);
            setIsSelected(true);
        } else {
            setIsAvailable(false);
            setIsSelected(false);
        }
    }, [availability, day]);

    useEffect(() => {
        if (isAvailable === true) {
            setAvailableTimes(getTimeSlotsFromNumber(timeslot));
        }
    }, [timeslot, isAvailable]);

    useEffect(() => {
        if (!schedule) {
            return;
        }
        var dayString = getDayFromChar(day)
        if (isSelected === true && availability.includes(day)) {
            if (schedule[dayString as unknown as keyof TutorSchedule] === 0) {
                const newSchedule = {...schedule} as TutorSchedule;
                newSchedule[dayString as unknown as keyof TutorScheduleNoTimeZone] = MaxNumber;
                setSchedule(newSchedule);
            }
        }
    }, [schedule, day, isSelected, setSchedule, availability]);

    var classDaySection = "text-slate-700 rounded-md mb-2 py-2 px-2 border " + colorBackground + " " + bordercolor + " " + textcolor;

    const setTimeSlot = (start: number, end: number): void => {
        if (start < 0 || start > 48 || end < 0 || end > 48 || start > end) {
            return;
        }
        var timeSlotString = convertToBinary(timeslot);
        if (!timeSlotString.includes("0")) {
            //timeslot is full, thus remove all for adding a time slot
            timeSlotString = timeSlotString.replaceAll("1", "0");
        }
        for (let i = start; i < end; i++) {
            timeSlotString = timeSlotString.substring(0, i) + "1" + timeSlotString.substring(i + 1);
        }
        const newSchedule = {...schedule} as TutorSchedule;
        newSchedule[dayString as unknown as keyof TutorScheduleNoTimeZone] = convertToNumber(timeSlotString);
        setSchedule(newSchedule);
    }

    const removeTimeSlot = (index: number): void => {
        index += 1;
        timeslot = schedule[dayString as unknown as keyof TutorScheduleNoTimeZone];
        var timeSlotString = convertToBinary(timeslot);
        var timeslotnum = 0;
        var lastslot = "0";
        for (let i = 0; i < timeSlotString.length; i++) {
            if (timeSlotString[i] === "1") {
                if (lastslot === "0") {
                    timeslotnum++;lastslot = timeSlotString[i];
                }
            }
            lastslot = timeSlotString[i];
            if (timeslotnum === index) {
                while (i < timeSlotString.length && timeSlotString[i] === "1") {
                    timeSlotString = timeSlotString.substring(0, i) + "0" + timeSlotString.substring(i + 1);
                    i++;
                }
                break;
            }
        }
        const newSchedule = {...schedule} as TutorSchedule;
        newSchedule[dayString as unknown as keyof TutorScheduleNoTimeZone] = convertToNumber(timeSlotString);
        setSchedule(newSchedule);
    }

    const handleSliderChange = (value: number[]): void => {
        setSliderValue(value);
    }

    const changeToAvailable = function (label: string, val: boolean): void {
        var newSchedule = {...schedule} as TutorSchedule;
        if (val === true) {
            if (!availability.includes(day)) {
                setAvailability(availability + day);
                newSchedule[dayString as unknown as keyof TutorScheduleNoTimeZone] = MaxNumber;
                setSchedule(newSchedule);
                setIsSelected(true);
            }
        } else {
            if (availability.includes(day)) {
                setAvailability(availability.replace(day, ""));
                newSchedule[dayString as unknown as keyof TutorScheduleNoTimeZone] = 0;
                setIsAdding(false);
                setSchedule(newSchedule);
                setIsSelected(false);
            }
        }
    }

    const handleAddTimeSlot = (): void => {
        setTimeSlot(sliderValue[0], sliderValue[1]);
        setIsAdding(false);
    }

    return (
        <div className={classDaySection}>
            <div className="text-sm flex flex-row grow ">
                <div className="text-sm flex flex-row grow font-medium ">
                    <CheckBox label={dayString} onValueChange={changeToAvailable} Value={isAvailable} name={dayString}></CheckBox>
                </div>
                {/* <div className="flex flex-row">
                    {isAvailable === true ? <Badge label="5 Sessions Booked!" color="yellow"></Badge> : <div className="text-sm flex flex-row grow"/>}
                </div> */}
            </div>
            {isAvailable === true ? 
                <div className="text-sm flex flex-col grow">
                    {setAvailableTimesRows()}
                </div> : <div className="text-sm flex flex-row grow"/>}
            <div className="text-sm flex flex-row-reverse grow gap-4">
                {addTimeSlot()}
            </div>
            {addTimeSlotSlider()}
        </div>
    );

    function setAvailableTimesRows(): JSX.Element {
        var renderHTML;
        if (timeslot === MaxNumber) {
            renderHTML = (<div className="text-sm flex flex-row grow pl-20 gap-4">
                <div> <FontAwesomeIcon icon={faClock} /></div>[DEFAULT ANYTIME]
            </div>)
        } else {
            renderHTML = <>{availableTimes.map((availableTime, index) => availableTimesRow(availableTime, index))}</>;
        }
        return renderHTML;
    }

    function availableTimesRow(label: string, index: number): JSX.Element {
        return (
            <div className="text-sm flex flex-row grow pl-20 items-center gap-4" key={index}>
                <FontAwesomeIcon icon={faClock} />
                <div className="w-30">{label}</div>
                <div onClick={() => removeTimeSlot(index)} className="hyperlink" > x</div>
            {/*<button className="time-slot-button" onClick={() => removeTimeSlot(index)}>*/}
            {/*    x*/}
            {/*</button>*/}
        </div>);
    }

    function addTimeSlot(): JSX.Element {
        if (!isAvailable) {
            return <div className="text-sm flex flex-row grow"/>;
        }

        if (!isAdding) {
            return (
                <button className="primary-button" onClick={() => {setIsAdding(true);setSliderValue([0, 48])}}>
                    Add
                </button>
            );
        } else {
            return (
                <button className="primary-button" onClick={() => setIsAdding(false)}>
                    Cancel
                </button>
            );
        }
    }

    function addTimeSlotSlider(): JSX.Element {
        if (!isAdding) {
            return <div className="text-sm flex flex-row grow"/>;
        } else {
            return (
                <>
                    <div className="flex flex-col w-full mt-12 mb-4">
                        <ReactSlider
                        className="m-2"
                        marks={1}
                        min={0}
                        max={48}
                        minDistance={1}
                        defaultValue={[0, 48]}
                        onChange={(value) => {handleSliderChange(value)}}
                        renderThumb={(props, state) => renderThumb(props, state)}
                        renderTrack={(props, state) => renderTrack(props, state)}
                        />
                    </div>
                    <button className="primary-button" onClick={handleAddTimeSlot}>
                        Add
                    </button>
                </>
            );
        }
    }

    function renderThumb(props: any, state: any) {
        const { key, ...restProps } = props;
        return (
            <div
                  {...restProps}
                  key={key}
                  style={{ ...restProps.style, zIndex: 20 }}
                  className="relative flex flex-col items-center w-8 h-8 -mt-4 outline-none"
                >
                  <div className="absolute top-0 inline-block px-2 py-1 mb-2 -mt-8 text-xs text-white bg-gray-900 rounded-sm whitespace-nowrap">
                    {getTimeString(state.valueNow)}
                  </div>
                  <div className="w-5 h-5 bg-white border-4 border-blue-700 rounded-full shadow-lg cursor-pointer" />
            </div>
        )
    }

    function renderTrack(props: any, state: any) {
        const { key, ...restProps } = props;
        return (
            <div
                key={key}
                {...restProps}
                className='h-1 rounded-full cursor-pointer bg-blue-700 -mt-2'
            />
        );
    }
}


